export default __webpack_public_path__ + "static/media/jan2024-4.04695899.jpg";